module.exports = __webpack_public_path__ + "img/intro_phone4.6284fe8e.png";